<div
    class="w-full divide-y divide-gray-100 dark:divide-white/10 overflow-hidden shadow-card-container-pale flex flex-col max-h-full">
    <div class="shrink-0 p-2 flex flex-wrap items-center justify-between sm:flex-nowrap">

        <div class="flex items-center">
            <div class="shrink-0">
                <div
                    class="size-10 rounded-xl bg-emerald-500/20 text-emerald-500 text-sm font-semibold flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6">
                        <path
                            d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2" />
                    </svg>
                </div>

            </div>
            <div class="ml-4">
                <h3 class="text-md font-semibold text-primary">Active Monitoring</h3>
                <p class="text-sm text-secondary">
                    Monitoring tasks in progress.
                </p>
            </div>
        </div>

        <div class="flex shrink-0 flex-row items-center justify-end gap-x-2">

        </div>
    </div>

    <div class="flex-1 flex flex-col px-2 py-2 overflow-hidden">
    </div>
</div>